import { render, staticRenderFns } from "./CategoryBars.vue?vue&type=template&id=1e798928&scoped=true&"
import script from "./CategoryBars.vue?vue&type=script&lang=js&"
export * from "./CategoryBars.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBars.vue?vue&type=style&index=0&id=1e798928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e798928",
  null
  
)

export default component.exports